import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InvoiceDurationType, TransformInvoiceResponse } from './invoices.types'

export interface InvoiceState {
  selectedInvoice: TransformInvoiceResponse | undefined
  selectedOrderId: string
  selectedInvoiceId: string
  selectedCustomerId: string
  duration: InvoiceDurationType
  invoiceEmailFrom: string
  invoiceEmailTo: string
  invoiceEmailSubject: string
  invoiceEmailMessage: string
  invoiceEmailAttachments: string[]
}

const initialState: InvoiceState = {
  selectedInvoice: undefined,
  selectedOrderId: '',
  selectedInvoiceId: '',
  selectedCustomerId: '',
  duration: 'All',
  invoiceEmailFrom: 'invoice@transpots.com',
  invoiceEmailTo: '',
  invoiceEmailSubject: '',
  invoiceEmailMessage: '',
  invoiceEmailAttachments: [],
}

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setSelectedInvoice: (
      state,
      action: PayloadAction<TransformInvoiceResponse>
    ) => {
      state.selectedInvoice = action.payload
    },
    clearSelectedInvoice: (state) => {
      state.selectedInvoice = undefined
    },
    setSelectedOrderId: (state, action: PayloadAction<string>) => {
      state.selectedOrderId = action.payload
    },
    clearSelectedOrderId: (state) => {
      state.selectedOrderId = ''
    },
    setSelectedInvoiceId: (state, action: PayloadAction<string>) => {
      state.selectedInvoiceId = action.payload
    },
    clearSelectedInvoiceId: (state) => {
      state.selectedInvoiceId = ''
    },
    setSelectedCustomerId: (state, action: PayloadAction<string>) => {
      state.selectedCustomerId = action.payload
    },
    clearSelectedCustomerId: (state) => {
      state.selectedCustomerId = ''
    },
    setDuration: (state, action: PayloadAction<InvoiceDurationType>) => {
      state.duration = action.payload
    },
    setInvoiceEmailFrom: (state, action: PayloadAction<string>) => {
      state.invoiceEmailFrom = action.payload
    },
    setInvoiceEmailTo: (state, action: PayloadAction<string>) => {
      state.invoiceEmailTo = action.payload
    },
    setInvoiceEmailSubject: (state, action: PayloadAction<string>) => {
      state.invoiceEmailSubject = action.payload
    },
    setInvoiceEmailMessage: (state, action: PayloadAction<string>) => {
      state.invoiceEmailMessage = action.payload
    },
    setInvoiceEmailAttachments: (state, action: PayloadAction<string[]>) => {
      state.invoiceEmailAttachments = action.payload
    },
    clearInvoiceEmail: (state) => {
      state.invoiceEmailFrom = ''
      state.invoiceEmailTo = ''
      state.invoiceEmailSubject = ''
      state.invoiceEmailMessage = ''
      state.invoiceEmailAttachments = []
    },
  },
})

export const {
  setSelectedInvoice,
  clearSelectedInvoice,
  setSelectedOrderId,
  clearSelectedOrderId,
  setSelectedInvoiceId,
  clearSelectedInvoiceId,
  setSelectedCustomerId,
  clearSelectedCustomerId,
  setDuration,
  setInvoiceEmailFrom,
  setInvoiceEmailTo,
  setInvoiceEmailSubject,
  setInvoiceEmailMessage,
  setInvoiceEmailAttachments,
  clearInvoiceEmail,
} = invoiceSlice.actions

export default invoiceSlice.reducer
